export default __webpack_public_path__ + "f134269d79284444e7a77f571e085b72.png";